<div id="<%= toast_window_id %>" class="toast mb-3 <%= classes %>" role="alert" aria-live="assertive" aria-atomic="true">
	<div class="toast-header text-light">
		<strong class="me-auto"><%- title %></strong>
		<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
	</div>
	<div class="toast-body position-relative">
		<%- message %>
	</div>
</div>
